import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Header from "./Components/header/header";
import Home from "./Components/home/Home";
import About from "./Components/about/About";
import Skills from "./Components/skills/Skills";
import Services from "./Components/services/Services";
import Qualification from "./Components/qualification/Qualification";
import Contact from "./Components/contact/Contact";
import Footer from "./Components/footer/Footer";
import ScrollUp from "./Components/scrollUp/ScrollUp";
import Work from "./Components/projects/Projects";
import DuckCursor from "./Components/duckCursor/DuckCursor";

import ProjectDetails from "./Components/projects/ProjectDetails";
import ScrollToTop from "./Components/ScrollToTopComp";
const App = () => {
  return (
    <BrowserRouter>
      <DuckCursor />
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header />

              <main className="main">
                <Home />
                <About />
                <Skills />
                {/* <Services /> */}
                <Qualification />
                <Work />
                <Contact />
              </main>
              <Footer />
              <ScrollUp />
            </>
          }
        />

        <Route
          path="/projects/:slug"
          element={
            <>
              <Header />
              <main className="main">
                <ProjectDetails />
              </main>
              <Footer />
            </>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
